/**
 * Admin Statistics Cards Component
 * Displays key metrics at the top of the admin dashboard
 */
import { Card, CardContent } from "../ui/card";
import { Users, Mail, Building2, UserCheck } from "lucide-react";

export function AdminStatsCards({ stats }) {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <Card className="bg-[#151A23] border-slate-700">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-slate-400 text-sm">Total Users</p>
              <p className="text-2xl font-bold text-white">{stats.users.total}</p>
              <p className="text-xs text-slate-500 mt-1">
                {stats.users.active} active
              </p>
            </div>
            <Users className="w-10 h-10 text-cyan-400/50" />
          </div>
        </CardContent>
      </Card>
      <Card className="bg-[#151A23] border-slate-700">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-slate-400 text-sm">Demo Requests</p>
              <p className="text-2xl font-bold text-white">{stats.demo_requests.total}</p>
              <p className="text-xs text-slate-500 mt-1">
                {stats.demo_requests.pending} pending
              </p>
            </div>
            <Mail className="w-10 h-10 text-amber-400/50" />
          </div>
        </CardContent>
      </Card>
      <Card className="bg-[#151A23] border-slate-700">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-slate-400 text-sm">Clinical Sites</p>
              <p className="text-2xl font-bold text-white">{stats.system.clinical_sites}</p>
            </div>
            <Building2 className="w-10 h-10 text-violet-400/50" />
          </div>
        </CardContent>
      </Card>
      <Card className="bg-[#151A23] border-slate-700">
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-slate-400 text-sm">Total Placements</p>
              <p className="text-2xl font-bold text-white">{stats.system.placements}</p>
            </div>
            <UserCheck className="w-10 h-10 text-green-400/50" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
